<template>
    <div class="col-12 nopads">
        <top-bar :current-view="views.USER_CAMPAIGN_VIEW" @onSignInClicked="showLogin"/>
        <alert
                :show="alertVisible"
                :message="message"
                :variant="variant"
                @alertShown=alertShown
        />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <div class="col-12 nopads mt-6" v-if="!showLoginForm">
                    <div class="content-header-container" v-if="user">
                        <span class="header-title">{{ user.first_name }} {{ user.last_name }}</span>
                    </div>
                    <keep-alive>
                        <transition name="fade" v-if="results.length>0 || user">
                            <campaign-feed :campaigns="results"/>
                        </transition>
                        <transition name="fase" v-else>
                            <no-results v-if="!loading"></no-results>
                        </transition>
                    </keep-alive>
                </div>
            </div>
            <footer-area />
        </div>
        <login v-if="showLoginForm"
               @loginUser="hideLogin"
               @close="hideLogin"
               @alert="showAlert">
        </login>
        <div v-if="loading"
             id="loader"
             class="spinner">
        </div>
    </div>
</template>

<script>
    import {alertMixin} from "../mixins/AlertMixin";
    import Alert from "../components/Alert";
    import {views} from "../mixins/ViewMixin";
    import {userHelper} from "../mixins/UserMixin";
    import FairApi from "../modules/api";
    import CampaignFeed from "../components/feed/CampaignFeed";
    import TopBar from "../components/TopBar";
    import NoResults from "../components/NoResults";
    import Login from "../components/Login";
    import FooterArea from "@/components/FooterArea";

    export default {
        name: "user-campaign-view",
        mixins: [alertMixin, views, userHelper],
        components: {FooterArea, Login, NoResults, TopBar, CampaignFeed, Alert},
        props: {
            id: {
                type: [Number, String],
                default: 0
            },
            userInfo: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                results:[],
                views,
                user: null,
                loading: false,
                showLoginForm: false
            }
        },
        mounted() {
            this.user = this.userInfo
            this.fetchUserCampaigns()
        },

        methods: {
            fetchUserCampaigns: function () {
                this.loading = true
                FairApi.getWithParams(FairApi.campaign(), {user: this.id, open: true},
                    this.success, this.failed)
            },

            success: function (response) {
                this.results = response
                if (this.results.length > 0) {
                    // get user data
                    this.user = this.results[0].user
                }
                this.loading = false
            },

            failed: function () {
                this.loading = false
                this.showAlert(this.$t('common.fetch_failed'))
            },

            showLogin: function () {
                this.showLoginForm = true
            },

            hideLogin: function () {
                this.showLoginForm = false
            }
        }
    }
</script>

<style scoped>

</style>